module.exports = __webpack_public_path__ + "img/app/home/img/icon-cuprum.c6e6bf6a3c8b44f86f80f1509c122d8e.png";